import { Paper } from '@mui/material'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'

import { hasFeature } from 'Common/environment'

type WrapperProps = {
    children: React.ReactNode
}

const shrinkPrintSx = {
    '@media print': {
        marginTop: 0,
        paddingTop: 0,
    },
}

export const ListWrapper = (props: WrapperProps) => {
    const { children } = props

    return (
        <Grid container spacing={1} size={12}>
            <Grid size={12}>
                <Paper sx={{ p: 2 }}>
                    <Grid size={12}>
                        <Grid container spacing={2} size={12}>
                            {children}
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    )
}

export const PageWrapper = (props: WrapperProps) => {
    const { children } = props

    return (
        <Container
            sx={{
                marginTop: hasFeature('newNavigation') ? 2 : 4,
                marginBottom: 2,
                minWidth: 0,
                ...shrinkPrintSx,
            }}
            maxWidth={false}
        >
            {children}
        </Container>
    )
}

export const TabsWrapper = (props: WrapperProps) => {
    const { children } = props

    return (
        <Container maxWidth={false} sx={{ ...shrinkPrintSx }}>
            {children}
        </Container>
    )
}

export const TabsPageWrapper = (props: WrapperProps) => {
    const { children } = props

    return (
        <Box sx={{ width: '100%', marginTop: 2, marginBottom: 2, ...shrinkPrintSx }}>
            {children}
        </Box>
    )
}

export const MainWrapper = (props: WrapperProps) => {
    const { children } = props

    return (
        <Grid container spacing={0} sx={{ ...shrinkPrintSx }} size={12}>
            {children}
        </Grid>
    )
}
